import React from "react"
import PropTypes from "prop-types"
import {RouterLink} from "@irati/ui/src/Link"
import id from "@irati/utils/id"

const NotFound = (props) => {
  const idNamespace = id("not-found", props, {force: true})
  return (
    <div id={idNamespace}>
      <span id={id("title", idNamespace)}>You are lost: </span>
      <RouterLink id={id("link-home", idNamespace)} styled={false} to="/" app="">Back Home</RouterLink>
    </div>
  )
}

NotFound.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default NotFound
